<script setup>
defineProps({
  label: String,
  icon: String,
  type: {
    type: String,
    default: "text",
  },
  placeholder: String,
  modelValue: String,
  error: String,
  passwordToggle: {
    type: Boolean,
    default: false,
  },
  showPassword: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["update:modelValue", "toggle-password"]);
</script>
<template>
  <div class="mb-3">
    <label v-if="label" class="form-label fw-semibold text-secondary">
      {{ label }}
    </label>

    <div class="input-group">
      <span v-if="icon" class="input-group-text bg-white border-end-0">
        <i :class="`bi ${icon}`"></i>
      </span>

      <input
        :type="type"
        class="form-control"
        :class="{ 'border-start-0': icon }"
        :placeholder="placeholder"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
      />

      <button
        v-if="passwordToggle"
        class="btn btn-outline-secondary"
        type="button"
        @click="$emit('toggle-password')"
      >
        <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
      </button>
    </div>

    <div v-if="error" class="text-danger small mt-1">
      {{ error }}
    </div>
  </div>
</template>
